import {crudGeneral} from "@/services/resource/GeneralCRUD.service";

export default {
    crudGeneral,
    data() {
        return {
            foreignKeyColumn: "",
            fields: [],
            listFormIsLoaded: true, //Formulário da listagem, por padrão na inclusão já virá carregado, pois virá em branco
            showLoadingList: true, //Por padrão sempre exibe o loading da listagem quando necessário
            listIsLoaded: false,
            listParams: new URLSearchParams(),
            items: [],
            fieldsNotReset: [],
            pathMethodComplement:"",
        }
    },
    props: {
        foreignKey: {
            type: Number,
            required: false,
        },
    },
    async mounted() {


    },
    methods: {

        onButtonSubmitText(command) {
            return this.t(command)
        },

        defaultFormList() {

            //Preenche os campos padrões que foram limpos após uma operação
            this.form[this.foreignKeyColumn] = this.foreignKey

        },

        mountedPrepareFormListDefault() {

            this.listParams.append(this.foreignKeyColumn, this.foreignKey.toString())

        },

        async mountedFormList() {
            await this.mountedForm(false, false, true)
        },

        async getList(pageNumber) {

            this.pageFormIsLoaded = true

            if (this.showLoadingList)
                this.listIsLoaded = false

            this.status = "" //Zera o status geral

            await crudGeneral.getAll(this.path + this.pathMethodComplement, pageNumber, this.listParams).then((response) => {
                    this.items = response.data
                    this.mountedList()
                }
            ).catch(error => this.responseError(error))

        },

        async setSendingFormListDefault(id) {

            this.setSending(
                id,
                () => {
                    this.clearFieldsCustomizable()
                    this.actionDefaultAfterCRUD()
                },
                () => {
                    this.clearFieldsCustomizable()
                    this.actionDefaultAfterCRUD()
                }, () => {
                    this.clearFieldsCustomizable()
                    this.actionDefaultAfterCRUD()
                },
            )

        },

        async actionDefaultAfterCRUD() {
            this.command = 'insert'
            await this.getList()
            this.resetFormDefault(this.form, this.fieldsNotReset)
            this.defaultForm()
        }

    },
    computed: {},
}